import { useMemo } from 'react';

export default function useAssemblyReadable(assembly) {
  const readable = useMemo(() => {
    if (!assembly) return {};

    const isMeeting = assembly.type === 'meeting';

    let castedType;
    if (isMeeting) castedType = 'Reunião';
    else castedType = `Assembleia ${assembly.type === 'ordinary' ? 'ordinária' : 'extraordinária'}`;

    return {
      isMeeting,
      title: isMeeting ? 'Reunião' : 'Assembleia',
      type: castedType,
      path: isMeeting ? 'meeting' : 'assembly',
    };
  }, [assembly]);

  return readable;
}
